<app-lfsa-card-v2 *ngIf="!mostrarFormulario" [innTemplateButton]="innTemplateButton" [innTemplate]="enviarTemplate"
                  [modulo]="DAT_TITULOS.modulo" [tituloCard]="titulo" [titulo]="DAT_TITULOS.titulo">
</app-lfsa-card-v2>
<ng-template #innTemplateButton>
  <div class="col-md-6">
    <div class="pagetitle">
      <div class="btn-group-justified btn-group" style="float: right;">
        <a (click)="nuevo()" class="btn btn-outline-success">
          <span class="fa fa-plus"></span>
          {{ DAT_TITULOS.nuevo }}
        </a>
        <a class="btn btn-outline-warning btn-outline"><i class="far fa-file-excel"></i></a>
      </div>
    </div>
  </div>
</ng-template>
<ng-template #enviarTemplate>
  <!-- <br> -->
  <section class="section">
    <div class="row">
      <div class="col-md-12 ">
        <app-lfsa-alerts [listaVacia]="listaVacia" [loading]="loading" [texto]="DAT_TITULOS.listaVacia">
        </app-lfsa-alerts>
        <ag-grid-angular #agGrid (gridReady)="onGridReady($event)" *ngIf="!listaVacia"
                         [columnDefs]="columnDefs" [floatingFilter]="true" [frameworkComponents]="frameworkComponents " [localeText]="AG_GRID_LOCALE_ES"
                         [pagination]="true"
                         [rowData]="rowData" [rowSelection]="rowSelection" [style]="modulo.agGrid.style"
                         class="ag-theme-alpine" [paginationPageSize]="modulo.agGrid.paginacion">
        </ag-grid-angular>
      </div>
    </div>
  </section>
</ng-template>

<app-lfsa-card-v2 *ngIf="mostrarFormulario" [innTemplate]="enviarTemplateForm" [modulo]="DAT_TITULOS.modulo"
                  [tituloCard]="titulo" [titulo]="DAT_TITULOS.titulo">
</app-lfsa-card-v2>
<ng-template #enviarTemplateForm>
  <form [formGroup]="formulario" class="form-group" novalidate>
    <div class="row">
      <div class="form-group col-md-6">
        <app-lfsa-combo-box [claseLabel]="'letrasDanger'" [comboBox]="cmbClientes"
                            [control]="formulario.get('cliente')" [idOpcion]="'cliId'" [id]="'cliente'"
                            [label]="'Cliente*'"
                            [opcion]="'cliNombre'" formControlName="cliente"></app-lfsa-combo-box>
      </div>
      <div class="form-group col-md-6">
        <app-lfsa-combo-box [claseLabel]="'letrasDanger'" [comboBox]="cmbArticulos"
                            [control]="formulario.get('articulo')" [idOpcion]="'artId'"
                            [id]="'articulo'" [label]="'Articulo*'"
                            [opcion]="'artDescripcion'" formControlName="articulo"></app-lfsa-combo-box>
      </div>
    </div>
    <div class="row">
      <div class="form-group col-md-4 ">
        <app-lfsa-input [claseLabel]="''" [control]="formulario.get('artCont')" [id]="'artCont'" [label]="'Contenedor'"
                        [placeholder]="'Ingrese Contenedor'" formControlName="artCont"></app-lfsa-input>
      </div>
      <div class="form-group col-md-4 ">
        <app-lfsa-input [claseLabel]="'letrasDanger'" [control]="formulario.get('paraKiloMinimo')" [id]="'paraKiloMinimo'"
                        [label]="'Kilos Minimo*'"
                        [placeholder]="'Ingrese Kilos Minimo'" formControlName="paraKiloMinimo"></app-lfsa-input>
      </div>
      <div class="form-group col-md-4 ">
        <app-lfsa-input [claseLabel]="'letrasDanger'" [control]="formulario.get('paraAmortiguador')"
                        [id]="'paraAmortiguador'" [label]="'Valor Amortiguador*'"
                        [placeholder]="'Ingrese Valor Amortiguador'"
                        formControlName="paraAmortiguador"></app-lfsa-input>
      </div>
    </div>
    <div class="row">
      <div class="form-group col-md-6 ">
        <app-lfsa-input [claseLabel]="'letrasDanger'" [control]="formulario.get('paraFechaInicioContrato')" [id]="'paraFechaInicioContrato'"
                        [label]="'Fecha Inicio Contrato*'" [placeholder]="'Ingrese Fecha Inicio Contrato'"
                        [type]="'date'"
                        formControlName="paraFechaInicioContrato"></app-lfsa-input>
      </div>
      <div class="form-group col-md-6 ">
        <app-lfsa-input [claseLabel]="'letrasDanger'" [control]="formulario.get('paraFechaFinContrato')" [id]="'paraFechaFinContrato'"
                        [label]="'Fecha Fin Contrato*'" [placeholder]="'Ingrese Fecha Fin Contrato'"
                        [type]="'date'"
                        formControlName="paraFechaFinContrato"></app-lfsa-input>
      </div>
    </div>
    <div class="row">
      <div class="form-group col-md-4 ">
        <app-lfsa-input [claseLabel]="'letrasDanger'" [control]="formulario.get('paraConsumoTotal')"
                        [id]="'paraConsumoTotal'" [label]="'Total a Consumir*'"
                        [placeholder]="'Ingrese Total a Consumir'"
                        formControlName="paraConsumoTotal"></app-lfsa-input>
      </div>
      <div class="form-group col-md-4 ">
        <app-lfsa-input [claseLabel]="'letrasDanger'" [control]="formulario.get('paraConsumido')"
                        [id]="'paraConsumido'" [label]="'Valor Consumido*'"
                        [placeholder]="'Ingrese Valor Consumido'" formControlName="paraConsumido"></app-lfsa-input>
      </div>
      <div class="form-group col-md-4 ">
        <app-lfsa-input [claseLabel]="'letrasDanger'" [control]="formulario.get('paraAlertStock')" [id]="'paraAlertStock'"
                        [label]="'Alerta Stock*'"
                        [placeholder]="'Ingrese Alerta Stock'" formControlName="paraAlertStock"></app-lfsa-input>
      </div>
    </div>
    <br>
    <app-lfsa-botones-formulario (devolverAccion)="acciones ( $event )" [formularioValido]="formulario.invalid"
                                 [textBoton]="textBoton"></app-lfsa-botones-formulario>
  </form>
</ng-template>
